import styled from 'styled-components';

export const ScrollRight = styled.div`
  position: fixed;
  right: 0;
  color: ${(props) => props.theme.palette.gray2};
  align-items: center;
  justify-content: center;
  z-index: 1001;
  cursor: pointer;
  animation: fadeOut 0.3s;
  transition: opacity 0.4s;
  top: 67px;
  background: white;
  padding: 8px 5px;
  min-height: 46px;
`;
